exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".table-background thead{background-color:#fff;border:2px solid #d3d3d3;border-bottom-style:none;height:40px;font-size:15px}.table-background th{color:#789;border:2px solid #d3d3d3;text-align:center;height:40px;font-size:15px}.table-background tr td{height:45px}.customRowClass,.table-background tr td{color:#000;border:1px solid #000;text-align:center;font-size:15px}.customRowClass{background-color:#a9e4ce;font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e85085a8","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/dashboard/assignmentPendency.vue
// module id = 1832
// module chunks = 0